// extracted by mini-css-extract-plugin
export default {"container":"container-w4XXo","title":"title-1rRUb","close":"close-1g73G","icon":"icon-2CB6s"};